import { useState, useEffect } from "react";
import { db } from "../../firebase";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";

export const getNewsletter = async (id, collectionName = "Newsletter") => {
  try {
    const docRef = doc(db, collectionName, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error fetching newsletter:", error);
    throw new Error(`Failed to fetch newsletter: ${error.message}`);
  }
};

export const useNewsletters = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewsletters = async () => {
      setIsLoading(true);
      setError(null);
      try {
        // console.log("Fetching all newsletters from Firestore");
        const querySnapshot = await getDocs(collection(db, "Newsletter"));
        const newsletters = [];
        querySnapshot.forEach((doc) => {
          newsletters.push({ id: doc.id, ...doc.data() });
        });
        // console.log("Fetched newsletters:", newsletters);
        setData(newsletters);
      } catch (err) {
        console.error("Error fetching newsletters:", err);
        setError(err.message || "Failed to fetch newsletters");
      } finally {
        setIsLoading(false);
      }
    };

    fetchNewsletters();
  }, []);

  return { data, isLoading, error };
};
